
export const GetLocalDrafts = () => {
    const drafts = [];
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);

        if (key.startsWith("Budget on: ")) {
            try {
                const item = JSON.parse(localStorage.getItem(key));

                const dateFromPrefix = key.replace("Budget on: ", "").trim().replace(/\/$/, "");

                drafts.push({
                    prefix: key,
                    name: item.title || "(Borrador sin título)",
                    customer: item.customerSearch || "",
                    status: "Borrador",
                    id: 0,
                    checkedAt: item.checkedAt || "",
                    createdAt: dateFromPrefix,
                    _lastModified: item._lastModified || new Date(0).toISOString(),
                    isLocal: true
                });
            } catch(e) {
                console.error("Error al leer el borrador local", key);
            }
        }
    }
    return drafts.sort((a, b) => new Date(b._lastModified) - new Date(a._lastModified));
};